import React from 'react';
import { Clock, Calendar } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export const KIND_LABELS = {
  primary_source: 'Primary Source',
  video: 'YouTube Video',
  channel: 'Channel',
};

export const KIND_COLORS = {
  primary_source: 'bg-blue-100 text-blue-900',
  video: 'bg-purple-100 text-purple-900',
  channel: 'bg-emerald-100 text-emerald-900',
};

const STATUS_BADGE_CLASSES = {
  complete: 'border-emerald-400 text-emerald-800',
  running: 'border-[#D4AF37]/40 text-[#14213D] animate-pulse',
  failed: 'border-red-400 text-red-800',
};

export const formatDuration = (sec) => {
  if (!sec && sec !== 0) return '—';
  if (sec < 60) return `${Math.round(sec)}s`;
  return `${Math.floor(sec / 60)}m ${Math.round(sec % 60)}s`;
};

export const formatTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
};

export const StatCard = ({ label, value, color, icon: Icon, testid }) => (
  <Card className="p-5" data-testid={testid}>
    <div className="flex items-center justify-between">
      <div>
        <div className="text-xs uppercase tracking-widest text-[#5A6577]">{label}</div>
        <div className={`text-3xl font-serif mt-1 ${color}`}>{value}</div>
      </div>
      {Icon && <Icon className={`h-7 w-7 ${color} opacity-70`} />}
    </div>
  </Card>
);

export const RunMetaRow = ({ run, polling }) => (
  <div className="flex flex-wrap items-center gap-x-6 gap-y-2 mb-6 text-xs text-[#5A6577]">
    <div className="flex items-center gap-1">
      <Clock className="h-3 w-3" />
      <span>Started: {formatTime(run?.started_at)}</span>
    </div>
    <div>Finished: {formatTime(run?.finished_at)}</div>
    <div>Duration: {formatDuration(run?.duration_sec)}</div>
    <Badge
      variant="outline"
      className={STATUS_BADGE_CLASSES[run?.status] || 'border-[#CBD5E0] text-[#5A6577]'}
      data-testid="link-health-status-badge"
    >
      {run?.status || 'never run'}
    </Badge>
    {polling && <span className="text-[#14213D]">auto-refreshing every 4s…</span>}
  </div>
);

export const ScheduleBanner = ({ scheduleInfo }) => {
  if (!scheduleInfo?.next_run) return null;
  return (
    <div className="mb-6 px-4 py-2 bg-emerald-50/60 border border-emerald-200 rounded-lg flex items-center gap-2 text-xs text-emerald-900" data-testid="schedule-info">
      <Calendar className="h-4 w-4" />
      <span><strong>Auto-check scheduled:</strong> daily at 6:00 AM Central. Next run: {formatTime(scheduleInfo.next_run)}. Admins get email if broken {'>'} 0.</span>
    </div>
  );
};
